import { BundleType } from '@peach/types/bundles/types.js';

/** How many calls a package may hold. */
export const CALLS_LIMITS = { min: 1, max: 50 } as const;

/** How long one call may be: the intro is short, a package's calls run longer. */
export function lengthLimits(type: BundleType): { min: number; max: number } {
  return type === BundleType.TRIAL ? { min: 10, max: 60 } : { min: 15, max: 180 };
}

/** What one tap of a price's − or + moves it by. */
export const priceStep = (type: BundleType): number => (type === BundleType.TRIAL ? 1 : 5);

/**
 * A number as typed, whole, or null when nothing numeric was typed. Rounded
 * rather than stripped of its point: "19.99" is 20, never 1999.
 */
export function parseTyped(text: string): number | null {
  const n = Math.round(parseFloat(text.replace(/[^\d.]/g, '')));
  return Number.isFinite(n) ? n : null;
}

export const clampTo = (n: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, n));
